<template>
    <div class="max-w-5xl mx-auto w-full space-y-8">
        <div
            v-if="showStepsIndicator"
            class="space-y-3 pt-4 max-w-2xl mx-auto"
        >
            <div class="flex items-center justify-between gap-4">
                <div
                    class="text-xs font-bold uppercase tracking-[0.24em] text-active"
                >
                    Onboarding Progress
                </div>
                <div class="text-sm font-semibold text-gray-500">
                    Step {{ stepNumber }} of {{ totalSteps }}
                </div>
            </div>

            <div class="h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
                <div
                    class="h-full rounded-full bg-active transition-all duration-300"
                    :style="{ width: getProgressBarWidth() }"
                ></div>
            </div>
        </div>

        <div class="space-y-2">
            <OnboardingStepContainerTitle>
                <slot name="title" />
            </OnboardingStepContainerTitle>
            <OnboardingStepContainerSubtitle>
                <slot name="subtitle" />
            </OnboardingStepContainerSubtitle>
        </div>

        <div class="w-full">
            <slot name="content" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import OnboardingStepContainerSubtitle from '@/App/Company/Component/OnboardingStepContainerSubtitle.vue'
    import OnboardingStepContainerTitle from '@/App/Company/Component/OnboardingStepContainerTitle.vue'

    const totalSteps = 7

    const props = defineProps({
        stepNumber: {
            type: Number,
            required: true,
        },
        showStepsIndicator: {
            type: Boolean,
            default: true,
        },
    })

    function getProgressBarWidth(): string {
        const progressPercentage = (props.stepNumber / totalSteps) * 100

        return `${Math.min(Math.max(progressPercentage, 0), 100)}%`
    }
</script>
